import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONLABORATORY_LOAD,
    ACTION_INSTITUTIONLABORATORY_LOAD_BY_ID,
    ACTION_INSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID,

    ACTION_INSTITUTIONLABORATORY_SAVE,

    ACTION_INSTITUTIONLABORATORY_CREATE,

    ACTION_INSTITUTIONLABORATORY_DELETE,

    ACTION_INSTITUTIONLABORATORY_VALIDATE,

    IInstitutionLaboratoriesLoadAction,
    IInstitutionLaboratoryLoadByIdAction,
    IInstitutionLaboratoryLoadByLaboratoryIdAction,
    IInstitutionLaboratoryLoadFailureAction,
    IInstitutionLaboratoryLoadSuccessAction,

    IInstitutionLaboratorySaveAction,
    IInstitutionLaboratorySaveSuccessAction,
    IInstitutionLaboratorySaveFailureAction,

    IInstitutionLaboratoryCreateAction,
    IInstitutionLaboratoryCreateSuccessAction,
    IInstitutionLaboratoryCreateFailureAction,

    IInstitutionLaboratoryDeleteAction,
    IInstitutionLaboratoryDeleteSuccessAction,
    IInstitutionLaboratoryDeleteFailureAction,

    IInstitutionLaboratoryValidateAction,
    IInstitutionLaboratoryValidateSuccessAction,
    IInstitutionLaboratoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

    ACTION_INSTITUTIONLABORATORY_LOAD_BY_INSTITUTION_ID,
    IInstitutionLaboratoryLoadByInstitutionIdAction,

} from "../actions/institutionLaboratory";
import { institutionLaboratoryApi } from "../services/institutionLaboratory";


export const
    getInstitutionLaboratoriesEpic = (action$): Observable<IInstitutionLaboratoryLoadSuccessAction | IInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_LOAD)
            .mergeMap((_action: IInstitutionLaboratoriesLoadAction) => {
                return institutionLaboratoryApi
                    .getInstitutionLaboratories()
                    .map(response =>
                        LoadSuccess(response.institutionLaboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionLaboratoryByIdEpic = (action$): Observable<IInstitutionLaboratoryLoadSuccessAction | IInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_LOAD_BY_ID)
            .mergeMap((action: IInstitutionLaboratoryLoadByIdAction) => {
                return institutionLaboratoryApi
                    .getInstitutionLaboratoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionLaboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionLaboratoryByLaboratoryIdEpic = (action$): Observable<IInstitutionLaboratoryLoadSuccessAction | IInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: IInstitutionLaboratoryLoadByLaboratoryIdAction) => {
                return institutionLaboratoryApi
                    .getInstitutionLaboratoryByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.institutionLaboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionLaboratoryByInstitutionIdEpic = (action$): Observable<IInstitutionLaboratoryLoadSuccessAction | IInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_LOAD_BY_INSTITUTION_ID)
            .mergeMap((action: IInstitutionLaboratoryLoadByInstitutionIdAction) => {
                return institutionLaboratoryApi
                    .getInstitutionLaboratoryByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionLaboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionLaboratoryEpic = (action$): Observable<IInstitutionLaboratorySaveSuccessAction | IInstitutionLaboratorySaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_SAVE)
            .mergeMap((action: IInstitutionLaboratorySaveAction) => {
                return institutionLaboratoryApi
                    .setInstitutionLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionLaboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionLaboratoryEpic = (action$): Observable<IInstitutionLaboratoryCreateSuccessAction | IInstitutionLaboratoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_CREATE)
            .mergeMap((action: IInstitutionLaboratoryCreateAction) => {
                return institutionLaboratoryApi
                    .createInstitutionLaboratory(action.laboratoryId, action.institutionId)
                    .map(response =>
                        CreateSuccess(response.institutionLaboratory, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    deleteInstitutionLaboratoryEpic = (action$): Observable<IInstitutionLaboratoryDeleteSuccessAction | IInstitutionLaboratoryDeleteFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_DELETE)
            .mergeMap((action: IInstitutionLaboratoryDeleteAction) => {
                return institutionLaboratoryApi
                    .deleteInstitutionLaboratory(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionLaboratoryEpic = (action$): Observable<IInstitutionLaboratoryValidateSuccessAction | IInstitutionLaboratoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONLABORATORY_VALIDATE)
            .mergeMap((action: IInstitutionLaboratoryValidateAction) => {
                return institutionLaboratoryApi
                    .validateInstitutionLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionLaboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }